import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import Chip from '@features/filter/Chip';
import Search from '@features/filter/Common/Search';
import Sort from '@features/filter/Common/Sort';

import { clearGlobalFilter } from '@store/actions/FilterAction';

const AssetsTopFilter = ({
	toggleFilter,
	activeTab,
	totalElements,
	setShowAddModal,
	artworkSummaryCount
}) => {
	const dispatch = useDispatch();
	const totalItems = totalElements ?? 0;

	const handleShowAddModal = () => {
		setShowAddModal(true);
	};

	const getPlaceholderText = (activeTab) => {
		let placeholder = '';
		if (activeTab === 'BLOCK_LIBRARY') {
			placeholder = 'Block title & number';
		} else if (activeTab === 'ARTWORK') {
			placeholder = 'Artwork Name & No';
		} else {
			placeholder = 'Reference number';
		}
		return placeholder;
	};

	useEffect(() => {
		dispatch(clearGlobalFilter());
	}, [activeTab, dispatch]);
	return (
		<div className="filter-container-top block-library-filter-top d-block pt-2 pb-2">
			<div className="d-flex align-items-center justify-content-between">
				<div className="filters">
					<div className="filter-toggle" onClick={toggleFilter}>
						<img src={`${process.env.PUBLIC_URL}/icons/filter24.svg`} alt="filter" />
						<span>Filter</span>
					</div>
					{activeTab === 'ARTWORK' ? (
						<ul className="list-item-with-dot">
							<li className="items-count semibold-14 gray_dark_02 mr-2">
								{totalItems > 1 ? `${totalItems} Files` : `${totalItems} File`}
							</li>
							<li className="items-count semibold-14 gray_dark_02 mr-1">
								{artworkSummaryCount?.totalCount > 1
									? `${artworkSummaryCount?.totalCount} Graphics`
									: `${artworkSummaryCount?.totalCount} Graphic`}
							</li>
							{artworkSummaryCount?.usedCount > 0 && (
								<li className="items-count semibold-14 gray_dark_02 mr-1">
									{artworkSummaryCount?.usedCount > 1
										? `${artworkSummaryCount?.usedCount} Used in styles`
										: `${artworkSummaryCount?.usedCount} Used in style`}
								</li>
							)}

							{artworkSummaryCount?.soldCount > 0 && (
								<li className="items-count semibold-14 gray_dark_02 mr-1">
									{artworkSummaryCount?.soldCount} Sold
								</li>
							)}
						</ul>
					) : (
						<span className="items-count semibold-14 gray_dark_02 mr-2">
							{totalItems > 1 ? `${totalItems} Items` : `${totalItems} Item`}
						</span>
					)}
				</div>
				<div className="filter-actions sample-dashboard-filter">
					<Search placeholder={getPlaceholderText(activeTab)} identifier="search" />
					{/* {activeTab === 'BLOCK_LIBRARY' && (
						<ListViewType
							type="BLOCK_LIBRARY_LIST"
							onSelectType={(selected) => onSetViewSetting(selected)}
						/>
					)} */}
					<div className="single-filter ml-3">
						<div className="transparent-sort">
							<Sort title={'ASSETS_LIST'} removedLastModified={activeTab !== 'ARTWORK'} />
						</div>
					</div>
					{(activeTab === 'SKETCH' || activeTab === 'ARTWORK') && (
						<button
							className="button text size32 px-0 d-flex align-items-center"
							onClick={handleShowAddModal}
						>
							<img src={`${process.env.PUBLIC_URL}/icons/add-round.svg`} alt="add" />
							<span className="ml-1">{activeTab === 'SKETCH' ? 'Sketch' : 'Artwork'}</span>
						</button>
					)}
				</div>
			</div>
			<Chip />
		</div>
	);
};

export default AssetsTopFilter;
